// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__hhjQz","header":"Header_header__Lhnr8","backIcon":"Header_backIcon__mygDq","headerName":"Header_headerName__pbsjs"};